import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import globals from '../Globals';

export default function PopularDestinations({ 
  title = "Destinations Populaires", 
  subtitle = "Best Sellers", 
  category = "voyage", 
  limit = 4, 
  excludeEventId = null,
  containerStyle = { marginBottom: '60px' }
}) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEvents();
  }, [category, limit, excludeEventId]);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${globals.API}/events`);
      const result = await response.json();
      
      if (result.success) {
        // Filter events by category, active status, and exclude the current event if any
        let filteredEvents = result.data.filter(
          event => event.category === category && event.isActive && event._id !== excludeEventId
        );

        // Shuffle uniquely
        const shuffled = filteredEvents.sort(() => Math.random() - 0.5);

        // Limit the number of events displayed
        const limitedEvents = shuffled.slice(0, limit);

        setEvents(limitedEvents);
      }
    } catch (error) {
      console.error('Error fetching events for popular destinations:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-xxl py-5 destination my-9" style={containerStyle}>
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          {subtitle && (
            <h6 className="bg-white text-center px-3" style={{ color: '#00338C', textTransform: 'uppercase', fontSize: '28px', fontWeight: 'bold', letterSpacing: '1px' }}>
              {subtitle}
            </h6>
          )}
          {title && (
            <h1 className="mb-5" style={{ color: '#01225C', fontWeight: 'bold', fontSize: '48px' }}>
              {title}
            </h1>
          )}
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border" style={{ color: '#2B4C7E', width: '3rem', height: '3rem' }} role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
          </div>
        ) : events.length > 0 ? (
          <div className="row g-4">
            {events.map((event, index) => {
              const price = event.departureDates && event.departureDates.length > 0 
                  ? event.departureDates[0].activePricing?.price 
                  : null;
              
              return (
                <div className="col-lg-3 col-md-6 col-sm-12 wow zoomIn" data-wow-delay={`0.${(index % 4) + 1}s`} key={event._id || index}>
                  <div 
                    className="position-relative d-block overflow-hidden"
                    style={{
                      cursor: 'pointer',
                      borderRadius: '12px',
                      height: '400px',
                      boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => {
                        window.scrollTo(0,0);
                        navigate(`/voyage/${event._id}`);
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 5px 20px rgba(0,0,0,0.05)';
                    }}
                  >
                    {/* Background Image */}
                    <img
                      src={event.image || `${process.env.PUBLIC_URL}/assets/img/placeholder.jpg`}
                      alt={event.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />

                    {/* Top-right eye icon */}
                    <div className="position-absolute" style={{ top: '15px', right: '15px' }}>
                        <i className="fa fa-eye text-white" style={{ fontSize: '24px' }}></i>
                    </div>

                    {/* Bottom Gradient Overlay */}
                    <div className="position-absolute bottom-0 start-0 w-100 d-flex flex-column justify-content-end p-4" style={{
                      background: 'linear-gradient(to top, rgba(0,34,91,0.9) 0%, rgba(0,34,91,0.6) 50%, transparent 100%)',
                      height: '60%'
                    }}>
                      {/* Title */}
                      <h4 className="text-white fw-bold mb-1" style={{ fontSize: '20px' }}>{event.title}</h4>
                      
                      {/* Destination Subtitle */}
                      <p className="text-white mb-3" style={{ fontSize: '13px', opacity: 0.9 }}>
                        {event.destination}
                      </p>

                      {/* Border line */}
                      <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(255,255,255,0.2)', marginBottom: '15px' }}></div>

                      <div className="d-flex justify-content-between align-items-end">
                        {/* Icons left */}
                        <div className="d-flex text-warning" style={{ gap: '8px', fontSize: '14px' }}>
                          <i className="fa fa-plane"></i>
                          <i className="fa fa-bed"></i>
                          <i className="fa fa-car"></i>
                          <i className="fa fa-percent"></i>
                        </div>

                        {/* Price right */}
                        <div className="text-end d-flex flex-column align-items-end">
                          <div className="text-white" style={{ fontSize: '11px', opacity: 0.8 }}>À partir de</div>
                          <div className="text-white fw-bold" style={{ fontSize: '24px' }}>
                            {price && price > 0 ? `${price} TND` : 'Sur demande'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-5">
            <p className="text-muted">Aucune destination trouvée.</p>
          </div>
        )}

        <div className="text-center mt-5">
          <button 
            className="btn" 
            style={{ 
              backgroundColor: '#ffffff',
              color: '#01225B', 
              border: '1px solid #01225B', 
              borderRadius: '8px', 
              padding: '12px 40px', 
              fontWeight: '600',
              fontSize: '16px',
              transition: 'all 0.3s'
            }}
            onClick={() => navigate('/voyage')}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f4f8fc';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ffffff';
            }}
          >
            Explorer plus
          </button>
        </div>
      </div>
    </div>
  );
}
